import * as React from "react";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import useLocales from "hooks/useLocales";

export default function BasicPopover() {
  const [open, setOpen] = React.useState(false);
  const { translate } = useLocales();

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <Button aria-describedby={id} variant="contained" onClick={handleClick}>
        Info
      </Button>
      <Popover
        id={id}
        open={open}
        onClose={handleClose}
        sx={{ transform: "translateY(50px)" }}
      >
        <Typography sx={{ p: 2 }}>
          {translate("Piano does not work on IOS")}
        </Typography>
      </Popover>
    </div>
  );
}
